import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  CircularProgress,
  Typography,
} from "@mui/material";
import { useDispatch } from "react-redux";
import { DeletePaymentMethod } from "../../redux/slices/payment";

const DeletePaymentMethodModal = ({ open, onClose, method, onDeleted }) => {
  const [submitting, setSubmitting] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!open) setSubmitting(false);
  }, [open]);

  const handleDelete = async () => {
    if (!method) return;
    try {
      setSubmitting(true);
      const res = await dispatch(DeletePaymentMethod(method._id));
      if (res) {
        onDeleted && onDeleted(res);
        onClose();
      }
    } catch (err) {
      // Delete thunk already shows toast; swallow here
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Confirm Delete</DialogTitle>
      <DialogContent>
        <Typography>
          Are you sure you want to delete "{method?.type || "this"}"?
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={submitting}>
          Cancel
        </Button>
        <Button
          onClick={handleDelete}
          color="error"
          variant="contained"
          disabled={submitting}
          startIcon={submitting ? <CircularProgress size={18} /> : null}
        >
          {submitting ? "Deleting" : "Delete"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeletePaymentMethodModal;
